import WebServiceRequest from '../Api/WebServiceRequest'

class GetAllDeliverySpeeds extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('GET')
        super.setTag('DeliverySpeeds/GetAllDeliverySpeeds')
    }

    setParams(data) {
        super.setRequestParam(data)
    }
}
class UpdateDeliverySpeedsValue extends WebServiceRequest {
    constructor(context) {
        super(context)
        super.setMethod('PUT')
        super.setTag('DeliverySpeeds/UpdateDeliverySpeedValue')
    }

    setParams(data) {
        super.setRequestParamDataObj(data)
    }
}
export {
    GetAllDeliverySpeeds,
    UpdateDeliverySpeedsValue
}